export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20vibrant%20entertainment%20TV%20studio%20stage%20with%20dramatic%20colorful%20spotlights%20in%20amber%20orange%20and%20coral%20red%20tones%2C%20modern%20broadcast%20studio%20design%20with%20large%20LED%20display%20screens%20showing%20abstract%20dynamic%20patterns%2C%20professional%20studio%20lighting%20grid%20on%20ceiling%2C%20warm%20atmospheric%20glow%2C%20entertainment%20variety%20show%20atmosphere%2C%20cinematic%20composition%2C%20rich%20textures%2C%20high-end%20production%20quality%2C%20no%20people&width=1600&height=900&seq=hero-bg-51movies&orientation=landscape"
          alt="51影视综艺演播室舞台场景"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>

      <div className="relative w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-300 text-sm font-medium mb-6 border border-accent-500/30 backdrop-blur-sm whitespace-nowrap">
              最新综艺 · 每日更新 · 高清免费
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
              <span className="text-primary-400">51影视</span>
              <br className="sm:hidden" />
              <span> 全网综艺免费高清在线观看</span>
            </h1>

            <p className="text-white/65 text-base md:text-lg font-medium mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
              热门综艺免费全集，高清不缓冲，随时随地畅享精彩内容
            </p>

            <p className="text-white/75 text-base md:text-lg leading-relaxed max-w-xl lg:max-w-none mx-auto lg:mx-0 mb-8">
              51影视网汇聚海量综艺节目资源，涵盖户外真人秀、音乐竞演、脱口秀、推理探案、恋爱观察等全品类内容。
              平台每日同步更新最新期数，采用智能 CDN 加速技术确保高清画质不缓冲，无需注册会员即可免费观看全集。
              无论你喜欢热血竞技还是治愈慢综，51影视都是你追综看综的首选平台。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-accent-400" style={{ fontFamily: 'var(--font-heading)' }}>2000+</div>
                <div className="text-white/60 text-xs md:text-sm mt-1">综艺节目</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-accent-400" style={{ fontFamily: 'var(--font-heading)' }}>每日更新</div>
                <div className="text-white/60 text-xs md:text-sm mt-1">30+ 期内容</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-accent-400" style={{ fontFamily: 'var(--font-heading)' }}>1080P</div>
                <div className="text-white/60 text-xs md:text-sm mt-1">高清流畅</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto whitespace-nowrap px-8 py-3.5 rounded-full bg-primary-500 text-white font-bold text-base hover:bg-primary-600 transition-all cursor-pointer text-center"
              >
                立即观看
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto whitespace-nowrap px-8 py-3.5 rounded-full bg-white/15 text-white font-semibold text-base hover:bg-white/25 backdrop-blur-sm transition-all cursor-pointer text-center border border-white/20"
              >
                热门榜单
                <i className="ri-fire-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dynamic%20entertainment%20variety%20show%20stage%20with%20warm%20orange%20and%20coral%20red%20spotlights%20crossing%20dramatically%2C%20modern%20studio%20design%20with%20sleek%20LED%20panels%20displaying%20colorful%20abstract%20graphics%2C%20professional%20broadcast%20cameras%20in%20silhouette%2C%20vibrant%20atmospheric%20stage%20fog%2C%20entertainment%20show%20production%20quality%2C%20warm%20intense%20lighting%2C%20cinematic%20depth%20of%20field%2C%20no%20visible%20people&width=600&height=750&seq=hero-visual-51movies&orientation=portrait"
                alt="51影视综艺节目主视觉 - 高清综艺免费在线观看"
                className="w-full h-auto object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                <div className="flex items-center gap-3">
                  <span className="w-3 h-3 rounded-full bg-accent-400 animate-pulse"></span>
                  <span className="text-white/90 text-sm font-medium">正在热播中</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}